/**
 *
 * @module entry
 * @desc {SDK.Test.Sequences} entry point.
 *
 */

import Playback from './media/playback';
import PlaybackCleanup from './media/playbackCleanup';
import PlaybackExternalAccount from './media/playbackExternalAccount';
import Commerce from './commerce/commerce';
import UserProfile from './userProfile/userProfile';
import CommerceStoredPayment from './commerce/commerceStoredPayment';
import UserActivity from './userActivity/userActivity';
import OneTimePasscode from './identity/bam/oneTimePasscode';

/**
 *
 * @typedef SDK.Test.Sequences
 * @type {Object}
 *
 * @property {Playback} Playback
 * @property {PlaybackCleanup} PlaybackCleanup
 * @property {PlaybackExternalAccount} PlaybackExternalAccount
 * @property {Commerce} Commerce
 * @property {UserProfile} UserProfile
 * @property {CommerceStoredPayment} commerceStoredPayment
 * @property {UserActivity} UserActivity
 * @property {OneTimePasscode} OneTimePasscode
 *
 */

/**
 *
 * @type {SDK.Test.Sequences}
 *
 */
export default {

    Playback,
    PlaybackCleanup,
    PlaybackExternalAccount,
    Commerce,
    UserProfile,
    CommerceStoredPayment,
    UserActivity,
    OneTimePasscode

};



// WEBPACK FOOTER //
// ./src/sequences/entry.js